import Footer from "../components/LandingScreenComponents/Footer";
import HeaderCompact from "../components/LandingScreenComponents/HeaderCompact";

const PrivacyPolicy = () => {
    return (
        <div className="flex flex-col px-4 pt-4 sm:px-6 lg:px-12">
        
        <HeaderCompact />
      <div className="w-[96%] md:w-[60%] mx-auto">
            <div className="prose max-w-none text-gray-800">
  <h2 className="text-xl font-bold mb-2">Privacy Policy</h2>
  <p className="mb-4">
    <strong>Effective Date:</strong> 09/15/2025<br />
    <strong>Entity Responsible:</strong> Kety, Inc., 4705 Bayview Drive, Plano, TX 75093, USA
  </p>

  <h3 className="text-lg font-semibold mb-2">1. Introduction</h3>
  <p className="mb-4">
    Solvi (“App,” “we,” “our,” or “us”) is operated by Kety, Inc. This Privacy Policy explains how we 
    collect, use, store, and share your information when you use Solvi. By using our App, you agree to 
    the terms of this Privacy Policy.
  </p>

  <h3 className="text-lg font-semibold mb-2">2. Information We Collect</h3>
  <ul className="list-disc list-inside mb-4 space-y-1">
    <li><strong>Account Information:</strong> Email address.</li>
    <li><strong>Wellness Information:</strong> Skin concerns, skincare routines, questionnaire responses.</li>
    <li><strong>Photos:</strong> Face snapshots, if you choose to upload them.</li>
    <li><strong>Location Data:</strong> General location for product relevance.</li>
    <li><strong>Usage Data:</strong> Analytics, log data, device information.</li>
  </ul>

  <h3 className="text-lg font-semibold mb-2">3. Special Note on Face Data</h3>
  <ul className="list-disc list-inside mb-4 space-y-1">
    <li><strong>What we collect:</strong> Face snapshots voluntarily uploaded by you.</li>
    <li><strong>Purpose of use:</strong> To help you visually track your skincare progress within the App. We do not analyze face data for identification, advertising, or AI training.</li>
    <li><strong>Who can see it:</strong> Only you within your account; we do not share face data with third parties.</li>
    <li><strong>Storage:</strong> Face snapshots are stored in Firebase. While we implement standard access controls, the data is not encrypted.</li>
    <li><strong>Retention:</strong> Face snapshots are automatically deleted after 30 days, unless you choose to delete them earlier.</li>
  </ul>

  <h3 className="text-lg font-semibold mb-2">4. Sharing of Information</h3>
  <p className="mb-2">We may share your information with trusted service providers, including:</p>
  <ul className="list-disc list-inside mb-4 space-y-1">
    <li><strong>Analytics & Infrastructure:</strong> Firebase, Google Analytics, Amplitude.</li>
    <li><strong>Advertising:</strong> Google Ads, Meta.</li>
    <li><strong>Payments & Subscriptions:</strong> RevenueCat, Stripe, Apple App Store, Google Play.</li>
    <li><strong>AI & Search Services:</strong> OpenAI, Algolia.</li>
  </ul>
  <p className="mb-4">We do not sell your personal information.</p>

  <h3 className="text-lg font-semibold mb-2">5. Data Storage & Security</h3>
  <p className="mb-4">
    Your information is stored in Firebase and protected with appropriate security measures. 
    We retain data only as long as necessary to provide services.
  </p>

  <h3 className="text-lg font-semibold mb-2">6. Your Rights</h3>
  <ul className="list-disc list-inside mb-4 space-y-1">
    <li><strong>GDPR (EU/UK):</strong> Access, correct, delete, or request portability of your data.</li>
    <li><strong>CCPA/CPRA (California):</strong> Right to know, delete, and opt-out of “sale” of personal data.</li>
    <li>
      <strong>Account Deletion:</strong> You may request deletion anytime by contacting{" "}
      <a className="underline text-blue-600" href="mailto:support@solvi.club">
        support@solvi.club
      </a>.
    </li>
  </ul>

  <h3 className="text-lg font-semibold mb-2">7. Children’s Privacy</h3>
  <p className="mb-4">
    Our App is intended for adults only. We do not knowingly collect data from children under 13.
  </p>

  <h3 className="text-lg font-semibold mb-2">8. International Users</h3>
  <p className="mb-4">
    Your data may be transferred and stored outside your country, including in the United States.
  </p>

  <h3 className="text-lg font-semibold mb-2">9. Contact Us</h3>
  <address className="not-italic mb-4">
    Kety, Inc.<br />
    4705 Bayview Drive<br />
    Plano, TX 75093<br />
    Email (only support channel):{" "}
    <a className="underline text-blue-600" href="mailto:support@solvi.club">
      support@solvi.club
    </a>
  </address>
  <p>We provide customer support exclusively via email.</p>
</div>

      </div>
      <Footer />
        </div>
    )
};




export default PrivacyPolicy;